'use strict';

wbApp.directive('wbAlert', ['$timeout', '$alert', 'notificationSvc',
    function ($timeout, $alert, notificationSvc) {
        return {
            restrict: 'A',
            priority: 1,
            replace: true,
            scope: {},
            link: function (scope, elm, attrs, controller) {
            },
            controller: ['$scope', function ( $scope ) {
                $scope.queue = notificationSvc.getQueue();

                $scope.$watchCollection('queue', function (newCollection, oldCollection, scope)
                {
                    if (newCollection.length) {
                        var newMessage = newCollection[0];
                        newCollection.splice(0, 1);

                        var myAlert = $alert(
                        {
                            title: newMessage.title,
                            content: newMessage.content,
                            placement: 'top-right',
                            animation: 'am-fade-and-scale',
                            container: '#alertContainer',
                            type: newMessage.type,
                            show: true
                        });

                        $timeout(function () {
                            myAlert.hide();
                        }, 5000)
                    }
                });

            }]
        }
    }]);